import { render, staticRenderFns } from "./States.vue?vue&type=template&id=0580c960"
import script from "./States.vue?vue&type=script&lang=js"
export * from "./States.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports